// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7ba5ad76","732":"14e22526","977":"98454615"}[chunkId] + ".chunk.js";
};